import { ca } from '@cian/analytics';

export enum EReplyTemplateTrackingSource {
  TextField = 'text_field',
  Attachment = 'attachment',
  ChatMessage = 'chat_message',
  AddReplyTemplate = 'add_reply_template',
}

export const trackReplyTemplateButtonClick = ({
  chatId,
  opponentId,
  source,
}: {
  chatId?: string;
  opponentId?: number;
  source: EReplyTemplateTrackingSource;
}) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat',
    action: 'Click_sopr',
    label: 'reply_template',
    page: {
      extra: {
        chat_id: chatId,
        opponent_id: opponentId,
        source,
      },
    },
  });
};

export const trackReplyTemplateCreateModalOpen = ({
  chatId,
  opponentId,
  source,
}: {
  chatId: string | undefined;
  opponentId: number | undefined;
  source: EReplyTemplateTrackingSource;
}) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat',
    action: 'Open',
    label: 'create_reply_template_screen',
    page: {
      extra: {
        chat_id: chatId,
        opponent_id: opponentId,
        source,
      },
    },
  });
};

export const trackReplyTemplateCreateSuccess = ({
  chatId,
  opponentId,
  replyTemplateId,
}: {
  chatId: string | undefined;
  opponentId: number | undefined;
  replyTemplateId: number;
}) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat',
    action: 'Click',
    label: 'create_reply_template_success',
    page: {
      extra: {
        chat_id: chatId,
        opponent_id: opponentId,
        reply_template_id: replyTemplateId,
      },
    },
  });
};

export const trackReplyTemplateListModalOpen = ({
  chatId,
  opponentId,
  source,
}: {
  chatId: string | undefined;
  opponentId: number | undefined;
  source: EReplyTemplateTrackingSource;
}) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat',
    action: 'Open',
    label: 'reply_template_list',
    page: {
      extra: {
        chat_id: chatId,
        opponent_id: opponentId,
        source,
      },
    },
  });
};

export const trackReplyTemplateItemClick = ({
  chatId,
  opponentId,
  replyTemplateId,
}: {
  chatId: string | undefined;
  opponentId: number | undefined;
  replyTemplateId: number;
}) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat',
    action: 'Click',
    label: 'reply_template_click',
    page: {
      extra: {
        chat_id: chatId,
        opponent_id: opponentId,
        reply_template_id: replyTemplateId,
      },
    },
  });
};

export const trackReplyTemplateEditClick = ({
  chatId,
  opponentId,
  replyTemplateId,
}: {
  chatId: string | undefined;
  opponentId: number | undefined;
  replyTemplateId: number;
}) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat',
    action: 'Click',
    label: 'edit_reply_template_click',
    page: {
      extra: {
        chat_id: chatId,
        opponent_id: opponentId,
        reply_template_id: replyTemplateId,
      },
    },
  });
};

export const trackReplyTemplateEditSuccess = ({
  chatId,
  opponentId,
  replyTemplateId,
}: {
  chatId: string | undefined;
  opponentId: number | undefined;
  replyTemplateId: number;
}) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat',
    action: 'Click',
    label: 'edit_reply_template_success',
    page: {
      extra: {
        chat_id: chatId,
        opponent_id: opponentId,
        reply_template_id: replyTemplateId,
      },
    },
  });
};

export const trackReplyTemplateDeleteSuccess = ({
  chatId,
  opponentId,
  replyTemplateId,
}: {
  chatId: string | undefined;
  opponentId: number | undefined;
  replyTemplateId: number;
}) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat',
    action: 'Click',
    label: 'delete_reply_template_success',
    page: {
      extra: {
        chat_id: chatId,
        opponent_id: opponentId,
        reply_template_id: replyTemplateId,
      },
    },
  });
};
